import React, { Component } from "react";
import TableWithLoadingWrapper from "../generic/dataGrid";

export default class GenericTableOnRowOnClick1 extends Component {
    render() {
        const {
            rowSelection,
            pagination,
            columns,
            dataSource,
            enableExpandable,
            handleExpand,
            tableLayout,
            style,
            components,
            loading,
            sortModel,
            footer,
            onChange,
            pageSizeOptions,
            transactionDrawerComponent,
            drawerWidth,
            checkboxSelection,
            selectionModel,
            numerator,
            denominator,
            onRowSelectionModelChange,
            optInRowHeightAuto,
        } = this.props;
        return (
            <TableWithLoadingWrapper
                // Table props
                columns={columns}
                dataSource={dataSource}
                rowSelection={rowSelection}
                pagination={pagination}
                pageSizeOptions={pageSizeOptions}
                enableExpandable={enableExpandable}
                tableLayout={tableLayout}
                sortModel={sortModel}
                style={{ width: "100%", ...style }}
                components={components}
                loading={loading || false}
                optInRowHeightAuto={optInRowHeightAuto}
                transactionDrawer={transactionDrawerComponent}
                drawerWidth={drawerWidth}
                footerFn={footer && footer()}
                numerator={numerator}
                denominator={denominator}
                onChange={onChange || undefined}
                // Handle row clicks
                onRowClick={(rowData) => {
                    if (handleExpand) {
                        handleExpand(enableExpandable, rowData); // Pass expandable status and row data
                    }
                }}
                checkboxSelection={checkboxSelection}
                selectionModel={selectionModel}
                onRowSelectionModelChange={onRowSelectionModelChange}
            />
        );
    }
}

